var PageSearchPassengers = (function ($) {

    PageSearchPassengers = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.locales = options['locales'];
        that.adult_categories = options['adult_categories'];
        that.child_categories = options['child_categories'];
        that.infant_categories = options['infant_categories'];
        that.$form = that.$wrapper.find('form');
        that.$submit = that.$form.find('.js-submit');
        that.$back_button = that.$form.find('.js-back-button');
        that.modals = options["modals"];

        that.$child_disclaimer_wrapper = that.$wrapper.find('.js-child-disclaimer-wrapper');
        
        that.$confirm_terms_checkbox = that.$wrapper.find('.js-confirm-terms-checkbox');
        that.$confirm_terms_checkbox_mobile = that.$wrapper.find('.js-confirm-terms-checkbox-mobile');
        that.$confirm_terms_link = that.$wrapper.find('.js-confirm-terms-link');
        that.$confirm_terms_text_more = that.$wrapper.find('.js-confirm-terms-text-more');
        that.$confirm_terms_text_less = that.$wrapper.find('.js-confirm-terms-text-less');
        that.$confirm_terms_ellipsis_wrapper = that.$wrapper.find('.js-confirm-terms-ellipsis-wrapper');
        
        that.$confirm_subsidy_quota = that.$wrapper.find('.js-confirm-subsidy-quota');

        // CONST
        that.hash = options['hash'];
        that.mobile_view_enabled = options['mobile_view_enabled'];
        that.search_params_string = options['search_params_string'];
        that.no_pricing = options['no_pricing'];
        that.locale = options['locale'];
        that.departure_date = options['departure_date'];
        that.departure_date_last = options['departure_date_last'];

        that.has_subsidy_quota = options.has_subsidy_quota || false;
        that.smartup_subscriber_birthday = options["smartup_subscriber_birthday"];
        that.smartup_companions_birthdays = options["smartup_companions_birthdays"];
        that.smartup_brand_included = options["smartup_brand_included"];
        that.contact_documents = options["contact_documents"] || [];

        that.class = {
            tooltip_terms: 'js-tooltip-terms',
            tooltip_subsidy_quota: 'js-tooltip-subsidy-quota',

            input_phone: 'js-phone',
            input_email: 'js-email',
            input_state_is_disabled: 'js-state-is-disabled',
            prevent_autofill: 'js-prevent-autofill',
            checkbox_confirm: 'js-checkbox-confirm',
            checkbox_icon: 'checkbox-icon',
            switch_save_passenger_data: 'js-enable-save-passenger-data',

            subsidy_repeat_check: 'js-button-subsidy-repeat-check',
            subsidy_modal_header_title: 'modal-header-title',
            subsidy_modal_description: 'js-subsidy-modal-description',
            subsidy_modal_content_with_passengers: 'js-subsidy-modal-content-with-passengers',
            subsidy_modal_content_fail: 'js-subsidy-modal-content-fail',
            subsidy_modal_sub_title_quota_exceed: 'js-subsidy-modal-sub-title-quota-exceed',
            subsidy_modal_sub_title_partially_failed: 'js-subsidy-modal-sub-title-partially-failed',
            subsidy_modal_why_we_check_block: 'js-subsidy-modal-why-we-check-block',
            subsidy_trip_from: 'js-subsidy-trip-from',
            subsidy_trip_one_way: 'js-subsidy-trip-ow',
            subsidy_trip_round_trip: 'js-subsidy-trip-rt',
            subsidy_trip_to: 'js-subsidy-trip-to',
            subsidy_passenger_list: 'js-subsidy-passenger-list',
            subsidy_passenger: 'js-subsidy-passenger',
            subsidy_passenger_name: 'js-subsidy-passenger-name',
            subsidy_passenger_data: 'js-subsidy-passenger-data',
            subsidy_passenger_error: 'js-subsidy-passenger-error',
            subsidy_passenger_quota_available: 'js-subsidy-passenger-quota-available',
            subsidy_passenger_quota_available_value: 'js-subsidy-passenger-quota-available-value',
            subsidy_passenger_quota_required: 'js-subsidy-passenger-quota-required',
            subsidy_passenger_quota_required_value: 'js-subsidy-passenger-quota-required-value',
            subsidy_passenger_not_enough: 'subsidy-not-enough',
            
            confirm_terms_text_wrapper: 'js-confirm-terms-text-wrapper',
            confirm_terms_wrapper_ellipsis: 'confirm-terms-ellipsis-wrapper',
            confirm_terms_wrapper_expanded: 'confirm-terms-expanded'
        };

        // DYNAMIC VARS
        /** @type {PassengerForm[]} */
        that.passenger_forms = [];

        that.is_locked = false;
        that.save_form_enabled = true;

        that.is_adult_exist = false;
        that.is_child_exist = false;

        // INIT
        that.init();
    };

    PageSearchPassengers.prototype.init = function () {
        var that = this;

        if (that.no_pricing) {
            that.__initNoPricingModal();
        }

        //
        that.__initChildDisclaimer();
        //
        that.__initPassengerForms();
        //
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        //
        UIInputMask.prototype.initEmailMask(that.$wrapper);
        //
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        //
        that.__initConfirmTerms();
        //
        that.__initConfirmSubsidyQuota();
        //
        that.__initForm();
        //
        that.handlerLoader();
    };

    // Public methods

    PageSearchPassengers.prototype.isValid = function () {
        var that = this;

        return that.__validate();
    }

    // Init methods

    PageSearchPassengers.prototype.__initNoPricingModal = function () {
        var that = this;

        $.uiModal({
            esc: false,
            custom_class: 'align-center',
            header_icons: '<i class="fab fa-sa-fill-mood-suprised"></i><i class="fab fa-sa-fill-plane"></i>',
            header_title: that.locale['no_pricing_modal']['title'],
            content: that.locale['no_pricing_modal']['content'],
            button_confirm_text: that.locale['no_pricing_modal']['button_text'],
            close_on_avia_before_load: false,
            onBgClick: function (modal, event) {
                event.preventDefault();
                return false;
            },
            onClose: function () {
                $.sa.content_router.load($.sa.build_url('search/' + that.search_params_string));
            }
        });
    };
    
    PageSearchPassengers.prototype.__initPassengersEqualNamesModal = function () {
        var that = this;
        
        $.uiModal({
            custom_class: 'align-center',
            header_icons: '<i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
            header_title: that.locale['passengers_equal_modal']['title'],
            content: that.locale['passengers_equal_modal']['content'],
            button_confirm_text: that.locale['passengers_equal_modal']['button_text'],
            onBgClick: function (modal, event) {
                event.preventDefault();
                return false;
            },
        })
    }

    PageSearchPassengers.prototype.__initChildDisclaimer = function () {
        var that = this,
            $disclaimer_close_button = that.$child_disclaimer_wrapper.find('.js-alert-button');

        $disclaimer_close_button.on('click', function (e) {
            e.preventDefault();

            that.__toggleChildDisclaimer(false);
        });
    }

    PageSearchPassengers.prototype.__initPassengerForms = function () {
        var that = this,
            $passenger_forms = that.$wrapper.find('.js-passenger-form');

        $.each($passenger_forms, function(i, form) {
            var $passenger_form = $(form),
                is_child = false,
                is_infant = false;

            if (that.adult_categories.includes($passenger_form.data('category'))) {
                that.is_adult_exist = true;
            }
            if (that.child_categories.includes($passenger_form.data('category'))) {
                that.is_child_exist = true;
                is_child = true;
            }
            if (that.infant_categories.includes($passenger_form.data('category'))) {
                is_infant = true;
            }

            var form_controller = new PassengerFormController($passenger_form, {
                passenger_index: i,
                is_infant: is_infant,
                page_controller: that
            });

            const passenger_form = form_controller.form;
            that.passenger_forms.push(passenger_form);
        });

        if (that.is_child_exist && !that.is_adult_exist) {
            that.__toggleChildDisclaimer(true);
        }
    };

    PageSearchPassengers.prototype.__getPassengerSsrs = function (passenger_index) {
        var that = this,
            data = that.__getFormData(),
            ssr_regexp = /ssrs\[(\d+)\]\[type\]/g;

        return data.filter(function (input_data) {
            var matches = ssr_regexp.exec(input_data.name);

            if (!matches) {
                return false;
            }

            var ssr_index = Number(matches[1]),
                passenger_input_data = data.find(function (inner_data) {
                    return inner_data.name === `ssrs[${ssr_index}][passenger_index]`;
                }) || {};

            if (passenger_input_data.value === String(passenger_index)) {
                return true;
            }
        });
    }

    PageSearchPassengers.prototype.__getMaxSsrIndex = function () {
        var that = this,
            data = that.__getFormData(),
            ssr_regexp = /ssrs\[(\d+)\]\[type\]/g,
            max_ssr_index = 0;

        data.forEach(function (input_data) {
            var matches = ssr_regexp.exec(input_data.name);

            if (!matches) {
                return;
            }

            var ssr_index = Number(matches[1]);

            if (ssr_index > max_ssr_index) {
                max_ssr_index = ssr_index;
            }
        });

        return max_ssr_index;
    }

    PageSearchPassengers.prototype.__initForm = function () {
        var that = this;

        //
        that.__initSaveFormData();
        //
        that.__initFillFormData();
        //
        that.$form.on('submit', function (e) {
            e.preventDefault();
            if (that.__validate()) {
                that.__submit();
            }
        });
    };

    PageSearchPassengers.prototype.__initSaveFormData = function () {
        var that = this;

        that.$form.on('input', function () {
            if (that.save_form_enabled) {
                setTimeout(function () {
                    that.__saveFormData();
                }, 10);
            }
        });
    };

    PageSearchPassengers.prototype.__initFillFormData = function () {
        var that = this;

        if (that.save_form_enabled) {
            that.__fillFormData();
        }
    };

    PageSearchPassengers.prototype.__initConfirmTerms = function () {
        var that = this,
            $checkbox_text_wrapper = that.$confirm_terms_ellipsis_wrapper,
            $checkbox_text = $checkbox_text_wrapper.find('.' + that.class.confirm_terms_text_wrapper);

        that.$confirm_terms_link.off('.analytics')
            .on('click.analytics', function() {
                $.sa.analytics.gtagSelectContent('reference', 'passenger_input_privacy_policy');
                return true;
            });
        
        that.$confirm_terms_checkbox.on('change', function () {
            var is_checked = that.$confirm_terms_checkbox.prop('checked');
            
            // sync checked state
            that.$confirm_terms_checkbox_mobile.prop('checked', is_checked);
            
            if (is_checked) {
                that.__toggleTermsTooltip(false);
            }
        });
        
        that.$confirm_terms_checkbox_mobile.on('change', function () {
            var is_checked_mobile = that.$confirm_terms_checkbox_mobile.prop('checked');
            
            // sync checked state
            that.$confirm_terms_checkbox.prop('checked', is_checked_mobile);
            
            if (is_checked_mobile) {
                that.__toggleTermsTooltip(false);
            }
        });
        
        that.__makeTextEllipsis($checkbox_text_wrapper, $checkbox_text);
        $.sa.$window.resize(function () { 
            that.__makeTextEllipsis($checkbox_text_wrapper, $checkbox_text); 
        });
        that.__lessMoreTextHandler();
    };

    PageSearchPassengers.prototype.__initConfirmSubsidyQuota = function () {
        var that = this;

        if (!that.has_subsidy_quota) {
            return;
        }

        that.$confirm_subsidy_quota.on('change', function () {
            if (that.$confirm_subsidy_quota.is(':checked')) {
                that.__toggleSubsidyQuotaTooltip(false);
            }
        });
    };

    // Validate methods

    PageSearchPassengers.prototype.__validate = function () {
        var that = this,
            departure_date = that.departure_date,
            departure_date_last = that.departure_date_last,
            is_valid = true;

        if (!that.__validatePassengerForms(departure_date, departure_date_last)) {
            is_valid = false;
        }

        if (!that.__validateEmail()) {
            if (is_valid) {
                that.__scrollToError(that.$wrapper.find(`.${that.class.input_email}`));
            }
            is_valid = false;
        }

        if (!that.__validatePhone()) {
            if (is_valid) {
                that.__scrollToError(that.$wrapper.find(`.${that.class.input_phone}`));
            }
            is_valid = false;
        }
        
        if (!that.$confirm_terms_checkbox.prop('checked') && $.sa.is_desktop()) {
            that.__toggleTermsTooltip(true);
            if (is_valid) {
                that.__scrollToError(that.$confirm_terms_checkbox.parent('label'));
            }

            is_valid = false;
        }
        
        if (!that.$confirm_terms_checkbox_mobile.prop('checked') && !$.sa.is_desktop()) {
            that.__toggleTermsTooltip(true);
            is_valid = false;
        }

        if (
            that.has_subsidy_quota &&
            that.$confirm_subsidy_quota.length &&
            !that.$confirm_subsidy_quota.is(':checked')
        ) {
            that.__toggleSubsidyQuotaTooltip(true);
            if (is_valid) {
                that.__scrollToError(that.$confirm_subsidy_quota.parent('label'));
            }
            is_valid = false;
        }

        if (
            is_valid &&
            (that.smartup_subscriber_birthday || that.smartup_brand_included) &&
            !that.__validateSmartup()
        ) {
            is_valid = false;
        }

        return is_valid;
    };

    PageSearchPassengers.prototype.__validatePassengerForms = function (departure_date, departure_date_last) {
        const that = this,
              is_desktop = $.sa.is_desktop();

        let is_valid = true,
            is_adults_age_valid = true,
            was_scrolled = false;

        if (that.is_child_exist && that.is_adult_exist) {
            is_adults_age_valid = false;
        }

        $.each(that.passenger_forms, function (i, passenger_form) {
            /** @type {PassengerForm} */
            if (!passenger_form.isValid(departure_date, departure_date_last)) {
                if (!was_scrolled) {
                    if (that.mobile_view_enabled && !is_desktop) {
                        passenger_form.form_controller.showFormBodyAtModal().then( function(response) {
                            const { $modal, modal_form } = response;
                            modal_form.isValid(departure_date, departure_date_last);
                            findAndViewError($modal);
                        });
                    } else {
                        findAndViewError(passenger_form.$wrapper);
                    }

                    was_scrolled = true;
                }

                is_valid = false;
            }

            if (
                that.is_child_exist &&
                that.is_adult_exist &&
                that.adult_categories.includes(passenger_form.category) &&
                passenger_form.isValidAdultAge(departure_date)
            ) {
                is_adults_age_valid = true;
            }
        });

        if (!is_adults_age_valid) {
            that.__showAdultInvalidAgeModal();
            is_valid = false
        }

        return is_valid;

        function findAndViewError($wrapper) {
            const $target = $wrapper.find(".error:visible:first");
            if ($target.length) {
                that.__scrollToError($target);
            }
        }
    };

    PageSearchPassengers.prototype.__validateSmartup = function () {
        var that = this,
            is_valid = true,
            smartup_subscriber_is_valid = true,
            smartup_companions_is_valid = true,
            smartup_companions_birthdays = Array.from(that.smartup_companions_birthdays),
            passengers_birthdays = [];

        $.each(that.passenger_forms, function (i, passenger_form) {
            passengers_birthdays[i] = passenger_form.getBirthday();
        });

        // subscriber validation
        if (that.smartup_subscriber_birthday || that.smartup_brand_included) {
            smartup_subscriber_is_valid = passengers_birthdays.indexOf(that.smartup_subscriber_birthday) !== -1;

            // if subscriber birthday is valid remove it from array of passengers_birthdays
            if (smartup_subscriber_is_valid) {
                passengers_birthdays.splice(passengers_birthdays.indexOf(that.smartup_subscriber_birthday), 1);
            }
        }

        // companions validation
        if (that.smartup_companions_birthdays) {
            passengers_birthdays.forEach(function (birthday){

                // if companion birthday valid remove it from array
                if (smartup_companions_birthdays.indexOf(birthday) !== -1) {
                    smartup_companions_birthdays.splice(smartup_companions_birthdays.indexOf(birthday), 1)
                } else {
                    smartup_companions_is_valid = false;
                    return false;
                }
            });
        }

        if (!smartup_subscriber_is_valid || !smartup_companions_is_valid) {
            is_valid = false;
            that.__renderSmartupInvalidModal();
        }

        return is_valid;
    };

    PageSearchPassengers.prototype.__renderSmartupInvalidModal = function () {
        var that = this,
            html = that.modals.smartup_passengers_invalid;

        $.uiModal({
            html: html,
            onOpen: function ($wrapper) {
                that.__modalSmartupButtonHandler($wrapper);
            }
        });
    };

    PageSearchPassengers.prototype.__modalSmartupButtonHandler = function ($wrapper) {
        var that = this,
            $button_submit = $wrapper.find('.js-modal-submit');

        $button_submit.on('click', function (){
            that.__submit();
        });
    };

    PageSearchPassengers.prototype.__validateEmail = function () {
        var that = this,
            $input = that.$wrapper.find(`.${that.class.input_email}`),
            result = $.trim($input.val()),
            required = $input.attr('required'),
            error_empty = $input.data('error-empty'),
            error_invalid = $input.data('error-invalid');

        UIInput.prototype.clearError($input);

        if (!result && required) {
            UIInput.prototype.setError($input, error_empty);
            return false;
        }

        if (result && !$.sa.validate.email(result)) {
            UIInput.prototype.setError($input, error_invalid);
            return false;
        }

        return true;
    };

    PageSearchPassengers.prototype.__validatePhone = function () {
        var that = this,
            $input = that.$wrapper.find(`.${that.class.input_phone}`),
            result = $.trim($input.val()),
            required = $input.attr('required'),
            error_invalid = $input.data('error-invalid'),
            error_empty = $input.data('error-empty');

        UIInput.prototype.clearError($input);

        if ((!result || result === '+7') && required) {
            UIInput.prototype.setError($input, error_empty);
            return false;
        }

        if (result && !UIInputMask.prototype.__validatePhone(result)) {
            UIInput.prototype.setError($input, error_invalid);
            return false;
        }

        return true;
    };

    // Submit methods

    PageSearchPassengers.prototype.__submit = function () {
        var that = this,
            href = $.sa.build_url('booking/create'),
            data = that.$form.find(":input[value!='']").serializeArray();

        data.push({
            name: 'hash',
            value: that.hash,
        });

        if (that.is_locked) {
            return false;
        }
        
        that.__handleSubmit();

        $.post(href, data, function (res) {
            if (!res) {
                res = {
                    status: 'fail',
                    errors: [
                        {
                            code: 0,
                            message: $.sa.locales['something_went_wrong'],
                        }
                    ],
                };
            }
            switch (res.status) {
                case 'ok':
                    that.__handleSuccess(res, data);
                    break;

                case 'fail':
                    that.__handleError(res);
                    break;
            }
        });
    };

    PageSearchPassengers.prototype.__lockFormsInputs = function (state) {
        var that = this;
        
        if (state === true) {
            that.passenger_forms.forEach(function (passenger_form){
                passenger_form.inputsLock();
            });
            that.__inputsLock();
        } else {
            that.passenger_forms.forEach(function (passenger_form){
                passenger_form.inputsUnlock();
            });
            that.__inputsUnlock();
        }
    };

    PageSearchPassengers.prototype.__handleSubmit = function () {
        var that = this;
        
        that.__formLock(true);
    };

    PageSearchPassengers.prototype.__handleSuccess = function (res, data) {
        var that = this;

        if (res.data.analytics_event_data) {
            $.sa.analytics.gtag('event', 'add_to_cart', res.data.analytics_event_data);
        }

        if (res.data.flocktory_event_data) {
            $.sa.flocktory.trackUserView(res.data.flocktory_event_data);
        }

        $.sa.content_router.load(that.__buildNextStepUrl(res.data.hash));
    }

    PageSearchPassengers.prototype.__handleError = function (res) {
        var that = this;

        that.__formLock(false);

        switch (res.errors[0].code) {
            case 40004:
                that.__initNoPricingModal();
                break;

            case 40010:
            case 40011:
            case 40012:
                that.__showSubsidyCheckFailedModal(res.errors[0] || {});
                break;
                
            case 40051:
                that.__initPassengersEqualNamesModal();
                break;

            default:
                $.each(res.errors, function (i, error) {
                    $.uiModal({
                        header_icons: '<i class="fab fa-sa-fill-circle-x"></i>',
                        header_title: $.sa.locales['error'] + ' ' + error.code,
                        content: error.message,
                        button_cancel_text: $.sa.locales['close']
                    });
                });
                break;
        }
    }

    PageSearchPassengers.prototype.handlerLoader = function () {
        var that = this;

        $.sa.$document.one('avia_before_load', function (){
            that.__lockFlowButtons(true);
        });

        $.sa.$document.one('avia_after_load', function (){
            that.__lockFlowButtons(false);
        });
    };

    PageSearchPassengers.prototype.__formLock = function (state) {
        var that = this;
        
        $.sa.buttonLoading(that.$submit, state);
        that.__lockFormsInputs(state);
        that.__lockFlowButtons(state);
        that.is_locked = state;
    };

    PageSearchPassengers.prototype.__lockFlowButtons = function (state) {
        var that = this;
        
        that.$submit.prop('disabled', state);

        if (state === true) {
            that.$submit.addClass('events-none');
            that.$back_button.addClass('events-none');
        } else {
            that.$submit.removeClass('events-none');
            that.$back_button.removeClass('events-none');
        }
    }

    // Actions TODO !!!!!!

    PageSearchPassengers.prototype.__saveFormData = function () {
        var that = this,
            $form_data = that.$form.find(":input[value!='']").serializeArray();

        localStorage.setItem('passenger_form_data', JSON.stringify($form_data));
    };

    PageSearchPassengers.prototype.__getFormData = function () {
        return JSON.parse(localStorage.getItem('passenger_form_data')) || [];
    };

    PageSearchPassengers.prototype.__fillFormData = function () {
        var that = this,
            data = that.__getFormData();

        if (!data) {
            return false;
        }

        data.forEach(function (value) {
            var $input = that.$form.find(`input[name="${value.name}"]`),
                $input_type = $input.attr('type');

            switch ($input_type) {
                case 'hidden':
                    if ($input.parents('.select').length && !$input.hasClass(that.class.prevent_autofill)) {
                        var $select = $input.parents('.select'),
                            $option = $select.find(`.option[data-value="${value.value}"]`);

                        UISelect.prototype._selectOption($select, $option);
                    }
                    break;

                case 'radio':
                    if (!$input.hasClass(that.class.prevent_autofill)) {
                        that.$form.find(`input[name="${value.name}"][value="${value.value}"]`).prop('checked', true).change();
                    }
                    break;

                case 'text':
                case 'email':    
                    if (!$input.hasClass(that.class.prevent_autofill)) {
                        $input.val(value.value).change();
                        if ($input.val().length) {
                            $input.parents('.input').addClass('not-empty');
                            $input.data('input_touched', true);
                        }
                    }
                    break;

                case 'checkbox':
                    if (!$input.hasClass(that.class.prevent_autofill)) {
                        that.$form.find(`input[name="${value.name}"]`).prop('checked', true).change();
                    }
                    break;
            }
        });
    };

    // Helpers

    PageSearchPassengers.prototype.__scrollToError = function($node) {
        var that = this;

        if ($node.length) {
            $node[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    PageSearchPassengers.prototype.__toggleChildDisclaimer = function (state) {
        var that = this;

        if (state) {
            that.$child_disclaimer_wrapper.show();
        } else {
            that.$child_disclaimer_wrapper.hide();
        }
    };

    PageSearchPassengers.prototype.__toggleTermsTooltip = function (state) {
        var that = this,
            $tooltip_terms = that.$wrapper.find('.' + that.class.tooltip_terms);

        if (state) {
            $tooltip_terms.css('opacity', '1');
        } else {
            $tooltip_terms.removeAttr('style');
        }
    };

    PageSearchPassengers.prototype.__toggleSubsidyQuotaTooltip = function (state) {
        var that = this,
            $tooltip_subsidy_quota = that.$wrapper.find(`.${that.class.tooltip_subsidy_quota}`);

        if (state) {
            $tooltip_subsidy_quota.css('opacity', '1');
        } else {
            $tooltip_subsidy_quota.removeAttr('style');
        }
    };

    PageSearchPassengers.prototype.__showAdultInvalidAgeModal = function () {
        var that = this,
            html = that.modals.adult_invalid_age;

        $.uiModal({
            html: html
        });

    };

    PageSearchPassengers.prototype.__buildNextStepUrl = function (order_hash) {
        return $.sa.build_url('order/' + order_hash + '/svcs');
    }

    PageSearchPassengers.prototype.__inputsLock = function () {
        var that = this,
            selectors = [
                '.' + that.class.input_email,
                '.' + that.class.input_phone,
                '.' + that.class.checkbox_confirm,
                '.' + that.class.switch_save_passenger_data
            ],
            $inputs = that.$wrapper.find(selectors.join(','));

        $inputs.each(function () {
            var $input = $(this);

            if ($input.prop('disabled')) {
                $input.addClass(that.class.input_state_is_disabled);
            }
            $input.prop('disabled', true);
        });
    };

    PageSearchPassengers.prototype.__inputsUnlock = function () {
        var that = this,
            selectors = [
                '.' + that.class.input_email,
                '.' + that.class.input_phone,
                '.' + that.class.checkbox_confirm,
                '.' + that.class.switch_save_passenger_data
            ],
            $inputs = that.$wrapper.find(selectors.join(','));

        $inputs.each(function () {
            var $input = $(this);

            if (!$input.hasClass(that.class.input_state_is_disabled)) {
                $input.prop('disabled', false);
            } else {
                $input.removeClass(that.class.input_state_is_disabled);
            }
        });
    };

    /**
     * Общее модальное окно для всех ошибок проверки субсидий
     *
     * @param {Object} error
     * @private
     */
    PageSearchPassengers.prototype.__showSubsidyCheckFailedModal = function (error) {
        var that = this,
            $html = $(that.modals.subsidy_fail).clone();

        if (error.message) {
            $html.find(`.${that.class.subsidy_modal_header_title}`).text(error.message);
        }

        if (error.description) {
            $html.find(`.${that.class.subsidy_modal_description}`).text(error.description);
        }

        if (error.code === 40010) {
            $html.find(`.${that.class.subsidy_modal_content_with_passengers}`).remove();
        } else {
            var $passenger_list = $html.find(`.${that.class.subsidy_passenger_list}`),
                $passenger_row = $passenger_list.find(`.${that.class.subsidy_passenger}`).first();

            if(error.code === 40011) {
                $html.find(`.${that.class.subsidy_modal_sub_title_quota_exceed}`).remove();
            } else {
                $html.find(`.${that.class.subsidy_modal_sub_title_partially_failed}`).remove();
                $html.find(`.${that.class.subsidy_modal_why_we_check_block}`).remove();
            }

            $html.find(`.${that.class.subsidy_modal_content_fail}`).remove();

            if (error.subsidy_passengers) {
                $passenger_list.empty();
                for (var passenger of Object.values(error['subsidy_passengers'])) {
                    var $row = $passenger_row.clone();

                    $row.find(`.${that.class.subsidy_passenger_name}`).text(passenger.name);
                    $row.find(`.${that.class.subsidy_passenger_data}`).text([
                        passenger['sex_short'],
                        passenger['citizenship_name'],
                        passenger['birthdate_formatted']
                    ].join(', '));

                    if (passenger['error_message']) {
                        $row.find(`.${that.class.subsidy_passenger_error}`).text(passenger['error_message']);
                        $row.find(`.${that.class.subsidy_passenger_quota_available}, .${that.class.subsidy_passenger_quota_required}`).remove();
                    } else {
                        $row.find(`.${that.class.subsidy_passenger_error}`).remove();
                        $row.find(`.${that.class.subsidy_passenger_quota_available_value}`).text(passenger['subsidy_available']);
                        $row.find(`.${that.class.subsidy_passenger_quota_required_value}`).text(error['required_quota_amount']);
                        if (passenger['subsidy_available'] >= error['required_quota_amount']) {
                            $row.find(`.${that.class.subsidy_passenger_quota_available}`).removeClass(that.class.subsidy_passenger_not_enough);
                        }
                    }
                    $passenger_list.append($row);
                }
                $passenger_row.remove();
                if (error.type === 'quota-exceed') {
                    $html.find(`.${that.class.subsidy_repeat_check}`).remove();
                }
            } else {
                that.__showSubsidyCheckFailedModal({code: 40010});
                return;
            }
        }

        $.uiModal({
            html: $html,
            esc: false,
            onBgClick(modal, event) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            },
            onOpen($wrapper, modal) {
                $wrapper.on('click', `.${that.class.subsidy_repeat_check}`, (event) => {
                    event.preventDefault();
                    modal.close()
                    that.$form.trigger('submit');
                });
            }
        });
    }
    
    PageSearchPassengers.prototype.__makeTextEllipsis = function ($wrapper, $inner) {
        var that = this;
        
        $wrapper.removeClass(that.class.confirm_terms_wrapper_ellipsis);
        that.$confirm_terms_text_more.hide();
        
        if (that.__isTextOverflow($wrapper, $inner)) {
            $wrapper.addClass(that.class.confirm_terms_wrapper_ellipsis);
            that.$confirm_terms_text_more.removeAttr('style');
        }
    }
    
    PageSearchPassengers.prototype.__lessMoreTextHandler = function () {
        var that = this;
        
        that.$confirm_terms_text_more.on('click', function (){
            that.$confirm_terms_ellipsis_wrapper.addClass(that.class.confirm_terms_wrapper_expanded);
        });
        
        that.$confirm_terms_text_less.on('click', function (){
            that.$confirm_terms_ellipsis_wrapper.removeClass(that.class.confirm_terms_wrapper_expanded);
        });
        
    }
    
    PageSearchPassengers.prototype.__isTextOverflow = function ($wrapper, $inner) {
        var that = this,
            wrapper_width,
            inner_width,
            inner_icon_width,
            button_more_width;
        
        wrapper_width = $wrapper.outerWidth();
        inner_width = $inner.outerWidth(true);
        inner_icon_width = $wrapper.find('.' + that.class.checkbox_icon).outerWidth(true);
        button_more_width = that.$confirm_terms_text_more.outerWidth(true);
        
        return (inner_width + inner_icon_width) > (wrapper_width + button_more_width);
    }

    return PageSearchPassengers;
})($);
